import { Card, Col, Row } from "react-bootstrap";
import IconActionCard from "../../shared/IconActionCard";
import { BsQuestionLg } from "react-icons/bs";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaFileInvoiceDollar } from "react-icons/fa6";
import { useAuthState } from "../../../context/AuthContext";
import MissingInvoiceModal from "../ElvMissingInvoiceModal";
import { TbCoins } from "react-icons/tb";
import ElvTeilVorschreibungModal from "../ElvTeilvorschreibungModal";
import { FaRegCalendarAlt } from "react-icons/fa";
import TzbChangeModal from "./TzbChangeModal";
import AreYouSureModal from "../../shared/AreYouSureModal";
import ChangePaymentModal from "./ChangePaymentModal";
import PrivateApi from "../../../services/PrivateApiService";
import { useQueryClient } from "react-query";
import { TicketTagIds } from "../../../constants/ticketTagIds";

const ActionsCard = ({ elv, energieprodukt, tickets }) => {

    const API = new PrivateApi();
    const queryClient = useQueryClient();
    const { user } = useAuthState();
    const navigate = useNavigate();
    const iconsSize = 30;

    const [showMissingInvoiceModal, setShowMissingInvoiceModal] = useState(false);
    const [showTzbModal, setShowTzbModal] = useState(false);
    const [showPaymentModal, setShowPaymentModal] = useState(false);
    const [showConfirmationModal, setShowConfimationModal] = useState(false);

    const [confirmationModalTitle, setConfirmationModalTitle] = useState("");
    const [confirmationModalText, setConfirmationModalText] = useState("");
    const [confirmationModalFunc, setConfirmationModalFunc] = useState(null);
    const [confirmationModalLoading, setConfirmationModalLoading] = useState(false);

    const posibleChangeAbrechnung = elv.x_monthly_invoice ? "Jährlich" : "Monatlich";
    const end = (elv?.x_datum_vertragsende && elv?.x_datum_vertragsende !== "False")
        ? new Date(elv?.x_datum_vertragsende)
        : new Date(new Date(elv?.x_belbeg).setFullYear(new Date(elv?.x_belbeg).getFullYear() + 1));

    const contractEnded = new Date() >= end;

    
    const openConfirmation = (title, text, handler)  => {
        setConfirmationModalTitle(title);
        setConfirmationModalText(text);
        setConfirmationModalFunc(handler);
        setShowConfimationModal(true);
    }

    const cancelTzbAction = () => {
        setConfirmationModalLoading(true);
        const ticket_id = tickets.find(t => t.tag_ids.includes(TicketTagIds.TZB))?.id;

        if (ticket_id) {
            API.get_Ticket_close(ticket_id)
                .then(() => {
                    queryClient.invalidateQueries("GET_ELV_DETAILS_QUERY");
                    setShowConfimationModal(false);
                })
                .finally(() => setConfirmationModalLoading(false));
        }
    }

    const cancelAbrechnungPlan = () => {
        setConfirmationModalLoading(true);
        const ticket_id = tickets.find(t => t.tag_ids?.includes(TicketTagIds.MP_Monatsrechnung))?.id;

        if (ticket_id) {
            API.get_Ticket_close(ticket_id)
                .then(() => {
                    queryClient.invalidateQueries("GET_ELV_DETAILS_QUERY");
                    setShowConfimationModal(false);
                })
                .finally(() => setConfirmationModalLoading(false));
        }
    }

    const askQuestionHandler = () => {
        if (user.x_is_house_management)
            navigate('/hw/dashboard/support/neu/elv', { state: { object: elv } })
        else
            navigate('/dashboard/support/neu/elv', { state: { object: elv } })
    };

    const requestInvoiceHandler = () => { setShowMissingInvoiceModal(true); }

    const changeTzbHandler = () => { setShowTzbModal(true); }
    const cancelTzbChangeHandler = () => {
        openConfirmation(
            "Anpassung Teilvorschreibung abbrechen", 
            "Sind Sie sicher, dass Sie die Anpassung der Teilvorschreibung abbrechen wollen?", 
            () => cancelTzbAction
        );
    }

    const changePaymentPlanHandler = () => { setShowPaymentModal(true); }
    const cancelChangeAbrechnungPlanHandler = () => {
        openConfirmation(
            `Änderung Abrechnungszeitraum`,
            `Sind Sie sicher, dass sie die Änderung des Abrechnungszeitraum auf ${posibleChangeAbrechnung} abbrechen wollen?`,
            () => cancelAbrechnungPlan
        );
    }

    return (
        <>
            <Card className="radius-20 shadow-lg">
                <Card.Body>
                    <h5>Aktionen</h5>
                    <Row className="mt-3">
                        <Col xs="12" md="6" xl="6" className="mt-3">
                            <IconActionCard
                                key={"qac"}
                                icon={<BsQuestionLg size={iconsSize} />}
                                title={"Frage zu diesem Vertrag"}
                                description={"Hier können Sie Fragen zu diesem Vertrag stellen"}
                                colorSchema={"energo"}
                                iconColor="light"
                                clickHandler={askQuestionHandler}
                            />
                        </Col>
                        <Col xs="12" md="6" xl="6" className="mt-3">
                            <IconActionCard
                                key="miac"
                                icon={<FaFileInvoiceDollar size={30} />}
                                title="Fehlende Abrechnung"
                                description="Hier können Sie eine nicht auffindbare Abrechnung nachfordern"
                                colorSchema="violet"
                                iconColor="light"
                                clickHandler={requestInvoiceHandler}
                            />
                        </Col>
                        <Col xs="12" md="6" xl="6" className="mt-3" hidden={elv.x_monthly_invoice || contractEnded}>
                            <IconActionCard
                                key="tzbac"
                                icon={<TbCoins size={30} />}
                                title="Teilvorschreibung ändern"
                                description="Hier können Sie die Höhe Ihrer Teilvorschreibung anpassen"
                                colorSchema="warning"
                                clickHandler={changeTzbHandler}
                                cancelHandler={cancelTzbChangeHandler}
                                inProgress={tickets?.some(t => t.tag_ids?.includes(TicketTagIds.TZB)) ?? false}
                            />
                        </Col>
                        <Col xs="12" md="6" xl="6" className="mt-3" hidden={elv.x_anlage_id.x_studio_field_3eKe0 !== "Strom" || elv.x_anlage_id.x_is_smartmeter_01 === false || contractEnded}>
                            <IconActionCard
                                key="mpac"
                                icon={<FaRegCalendarAlt size={30} />}
                                title={`${posibleChangeAbrechnung}e Abrechnung aktivieren`}
                                description={`Hier können Sie eine ${posibleChangeAbrechnung}e Abrechnung anfordern`}
                                colorSchema="primary"
                                iconColor="light"
                                clickHandler={changePaymentPlanHandler}
                                inProgress={tickets?.some(t => t.tag_ids?.includes(TicketTagIds.MP_Monatsrechnung)) ?? false}
                                cancelHandler={cancelChangeAbrechnungPlanHandler}
                            />
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            <MissingInvoiceModal show={showMissingInvoiceModal} setShow={setShowMissingInvoiceModal} elv={elv} />
            <ElvTeilVorschreibungModal  elv={elv} energieprodukt={energieprodukt} />
            <TzbChangeModal elv={elv} energieprodukt={energieprodukt} show={showTzbModal} setShow={setShowTzbModal} />
            <ChangePaymentModal show={showPaymentModal} setShow={setShowPaymentModal} elv={elv} wantedPayment={posibleChangeAbrechnung} />
            <AreYouSureModal 
                show={showConfirmationModal} 
                setShow={setShowConfimationModal}
                title={confirmationModalTitle}
                message={confirmationModalText}
                yesHandler={confirmationModalFunc}
                loading={confirmationModalLoading}
            />
        </>
    )
}
export default ActionsCard;